import { Link } from 'react-router-dom'

export function PublicFooter() {
  return (
    <footer className="bg-[#2D2A26] px-8 pb-7 pt-16">
      <div className="mx-auto grid max-w-[1120px] grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr]">
        {/* Brand */}
        <div>
            <Link to="/" className="flex items-center">
              <img src="/logo.png" alt="Masonyt" className="h-6" />
            </Link>
          <p className="max-w-[260px] text-[13px] leading-relaxed text-[#9C9689]">
            The trusted marketplace where businesses build quality custom software with elite,
            vetted developers.
          </p>
        </div>

        {/* Platform */}
        <div>
          <h4 className="mb-4 text-[11px] font-bold uppercase tracking-[2px] text-[#E8E4DD]">
            Platform
          </h4>
          <nav className="flex flex-col gap-2">
            <Link
              to="/process"
              className="text-[13px] text-[#9C9689] transition-colors hover:text-[#E8E4DD]"
            >
              Our Process
            </Link>
            <Link
              to="/security"
              className="text-[13px] text-[#9C9689] transition-colors hover:text-[#E8E4DD]"
            >
              Safety &amp; Security
            </Link>
            <Link
              to="/post"
              className="text-[13px] text-[#9C9689] transition-colors hover:text-[#E8E4DD]"
            >
              Post a Project
            </Link>
            <Link
              to="/developers"
              className="text-[13px] text-[#9C9689] transition-colors hover:text-[#E8E4DD]"
            >
              Browse Developers
            </Link>
          </nav>
        </div>

        {/* Developers */}
        <div>
          <h4 className="mb-4 text-[11px] font-bold uppercase tracking-[2px] text-[#E8E4DD]">
            Developers
          </h4>
          <nav className="flex flex-col gap-2">
            <Link
              to="/signup/developer"
              className="text-[13px] text-[#9C9689] transition-colors hover:text-[#E8E4DD]"
            >
              Join as Developer
            </Link>
            <Link
              to="/bounty-board"
              className="text-[13px] text-[#9C9689] transition-colors hover:text-[#E8E4DD]"
            >
              Bounty Board
            </Link>
          </nav>
        </div>

        {/* Company */}
        <div>
          <h4 className="mb-4 text-[11px] font-bold uppercase tracking-[2px] text-[#E8E4DD]">
            Company
          </h4>
          <nav className="flex flex-col gap-2">
            <Link
              to="/info"
              className="text-[13px] text-[#9C9689] transition-colors hover:text-[#E8E4DD]"
            >
              About
            </Link>
            <Link
              to="/agentic"
              className="text-[13px] text-[#9C9689] transition-colors hover:text-[#E8E4DD]"
            >
              Agentic Frameworks
            </Link>
            <a
              href="#"
              className="text-[13px] text-[#9C9689] transition-colors hover:text-[#E8E4DD]"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-[13px] text-[#9C9689] transition-colors hover:text-[#E8E4DD]"
            >
              Terms of Service
            </a>
          </nav>
        </div>
      </div>

      {/* Bottom */}
      <div className="mx-auto mt-9 max-w-[1120px] border-t border-[rgba(255,255,255,0.06)] pt-6 text-center">
        <p className="text-xs text-[#78736A]">
          &copy; {new Date().getFullYear()} Masonyt. All rights reserved.
        </p>
        <p className="mt-2 text-[11px] text-[#5C5650]">
          Illustrations by{' '}
          <a
            href="https://storyset.com/work"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#78736A] hover:underline"
          >
            Storyset
          </a>
        </p>
      </div>
    </footer>
  )
}
